function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgKeyAccessRed = function SvgKeyAccessRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M156.748,445.37c-9.848,0-24.225-4.823-56.162-40.565c-16.232-18.165-29.533-36.033-30.093-36.785 c-0.376-0.507-0.717-1.037-1.025-1.588c-6.071-10.933-9.281-23.321-9.281-35.827v-90.89c0-7.925,6.426-14.35,14.35-14.35h116.075 c16.625,0,32.307,6.421,44.155,18.082l59.435,58.483c17.218,17.218,17.218,45.102,0.083,62.239 c-0.026,0.024-0.146,0.145-0.171,0.169c-8.227,8.227-19.264,12.798-31.002,12.798c-11.741,0-22.777-4.572-31.078-12.873 l-59.37-59.37c-5.889-0.044-15.452-0.089-23.089-0.123l-10.867-0.052c-7.924-0.042-14.317-6.499-14.275-14.424 c0.04-7.899,6.459-14.275,14.348-14.275c0.026,0,0.05,0,0.076,0l10.85,0.052c6.786,0.03,14.038,0.065,19.606,0.099 c2.808,0.019,5.19,0.036,6.876,0.056c4.173,0.046,8.489,0.095,12.653,4.259l63.486,63.486c2.88,2.881,6.71,4.467,10.785,4.467 c4.074,0,7.904-1.586,10.784-4.467c0.026-0.026,0.146-0.145,0.171-0.169c5.873-5.873,5.873-15.549-0.075-21.496l-59.353-58.403 c-6.447-6.344-14.978-9.838-24.024-9.838H88.889v76.541c0,7.337,1.808,14.608,5.235,21.09c2.615,3.468,13.586,17.86,26.471,32.423 c25.476,28.797,35.211,32.208,36.504,32.554l155.149-0.032c10.577,0,22.902-5.538,34.621-11.208 c9.891-4.786,83.334-54.602,127.304-84.878c0.24-0.165,0.485-0.323,0.735-0.474c8.199-4.938,10.853-15.631,5.913-23.833 c-2.391-3.971-6.189-6.773-10.689-7.891c-4.414-1.095-8.989-0.441-12.91,1.842L350.036,361.28 c-6.605,4.379-15.512,2.574-19.889-4.028c-4.381-6.605-2.577-15.51,4.029-19.89l107.483-71.28c0.172-0.115,0.349-0.227,0.527-0.333 c21.754-13.104,50.116-6.064,63.223,15.694c13.018,21.623,6.147,49.766-15.285,62.975c-13.285,9.146-115.768,79.599-130.751,86.848 c-14.714,7.122-30.474,14.076-47.12,14.076l-155.497,0.032C156.752,445.37,156.749,445.37,156.748,445.37z"
  }), React.createElement("rect", {
    x: 14.35,
    y: 222.088,
    style: {
      fill: "#F4B2B0"
    },
    width: 84.146,
    height: 189.587
  }), React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M98.491,426.019H14.35c-7.924,0-14.35-6.424-14.35-14.35V222.088c0-7.925,6.426-14.35,14.35-14.35 h84.142c7.924,0,14.35,6.424,14.35,14.35v189.581C112.841,419.594,106.415,426.019,98.491,426.019z M28.699,397.319h55.443V236.437 H28.699V397.319z"
  }), React.createElement("circle", {
    style: {
      fill: "#F4B2B0"
    },
    cx: 347.835,
    cy: 153.009,
    r: 72.035
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M347.833,239.393c-47.632,0-86.383-38.751-86.383-86.383s38.751-86.383,86.383-86.383 s86.383,38.751,86.383,86.383S395.467,239.393,347.833,239.393z M347.833,95.326c-31.807,0-57.684,25.877-57.684,57.684 s25.877,57.684,57.684,57.684s57.684-25.877,57.684-57.684C405.519,121.203,379.641,95.326,347.833,95.326z"
  }), React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M275.8,167.36H132.328c-7.924,0-14.35-6.424-14.35-14.35v-40.083c0-7.925,6.426-14.35,14.35-14.35 s14.35,6.424,14.35,14.35v25.733H275.8c7.924,0,14.35,6.424,14.35,14.35C290.149,160.935,283.725,167.36,275.8,167.36z"
  }), React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M179.641,167.36c-7.924,0-14.35-6.424-14.35-14.35v-28.638c0-7.925,6.426-14.35,14.35-14.35 s14.35,6.424,14.35,14.35v28.639C193.991,160.935,187.567,167.36,179.641,167.36z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKeyAccessRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key-access-red.b1b9c996.svg";
export { ForwardRef as ReactComponent };